export class RichTextPromptElement extends HTMLElement {
  static tagName = "rich-text-prompt"

  setAttribute(name, value) {
    value ? super.setAttribute(name, value) : this.removeAttribute(name)
  }

  get autoload() {
    return this.hasAttribute("autoload")
  }

  set autoload(value) {
    this.toggleAttribute("autoload", value)
  }

  get busy() {
    return this.hasAttribute("busy")
  }

  set busy(value) {
    this.toggleAttribute("busy", value)
  }

  get src() {
    return this.getAttribute("src")
  }

  set src(value) {
    this.setAttribute("src", value)
  }
}

customElements.define(RichTextPromptElement.tagName, RichTextPromptElement)
